import { render } from "./App.vue?vue&type=template&id=41757d6e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=41757d6e&lang=css"

import exportComponent from "D:\\Hobby\\Javascript\\Sito_AS\\aperispeak\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__